﻿export interface Filter {
    name: string;
    color: string;
}

export enum BarOrientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical'
}
